'use client'
import dynamic from 'next/dynamic'
import React from 'react'

import type { FaqPageData } from '@src/components/blocks/faq-page-ds'
import FaqPageLegacy from '@src/quince-site-integrated/src/templates/faq-page-legacy'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { PageTemplateProps } from './page-templates.types'

// dynamic import keeps Panda styles out of the legacy bundle; ssr stays on for identical server HTML
const FaqPageDS = dynamic(
  () => import(/* webpackChunkName: "faq-page-ds" */ '@src/components/blocks/faq-page-ds/faq-page-ds'),
)

export default function FaqPageTemplate({ pageData }: PageTemplateProps) {
  const data = pageData.faqPage as FaqPageData

  if (shouldUseDesignSystem()) {
    return <FaqPageDS data={data} />
  }

  return <FaqPageLegacy data={data} />
}
